import { Flex, Input } from "antd";
import { FC, useCallback } from "react";
import { Option } from "tm-shared/types";

import SortIconAsc from "@/assets/icons/sort-icon-asc.svg?react";
import SortIconDesc from "@/assets/icons/sort-icon-desc.svg?react";
import { AppSelect } from "@/shared/forms";
import { PrimaryText } from "@/shared/ui";

interface SearchAndSortControlsProps {
    currentSortOption: Option;
    sortOptions: Option[];
    onChangeSort: (o: Option) => void;
    query: string;
    onChangeQuery: (q: string) => void;
    searchPlaceholder?: string;
}

export const SearchAndSortControls: FC<SearchAndSortControlsProps> = ({
    sortOptions,
    query,
    onChangeQuery,
    onChangeSort,
    currentSortOption,
    searchPlaceholder,
}) => {
    const handleChangeSortSelect = useCallback(
        (value: string) => {
            const selectedOption = sortOptions.find(
                (option) => option.value === value,
            );
            if (selectedOption) {
                onChangeSort(selectedOption);
            }
        },
        [onChangeSort, sortOptions],
    );

    return (
        <Flex gap={8} align="center">
            <Input.Search
                placeholder={searchPlaceholder}
                value={query}
                size="large"
                onChange={(e) => onChangeQuery(e.target.value)}
                allowClear
            />

            <AppSelect
                size="large"
                onChange={handleChangeSortSelect}
                options={sortOptions}
                placeholder="Оберіть сортування"
                value={currentSortOption}
                virtual={false}
                styles={{
                    popup: {
                        root: { width: 200 },
                    },
                    content: {
                        display: "none",
                    },
                }}
                suffixIcon={
                    <PrimaryText fontSize={24}>
                        {currentSortOption?.value?.includes("-desc") ? (
                            <SortIconDesc />
                        ) : (
                            <SortIconAsc />
                        )}
                    </PrimaryText>
                }
            />
        </Flex>
    );
};
